import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { PagedResult } from '../../models/pagedResult.model';
import { PageStats } from '../../models/pageStats.model';
import { FilterApplied } from '../../models/filterApplied.model';
import { FilterDescriptor } from '../../models/filterDescriptor.model';

@Injectable({
  providedIn: 'root'
})
export class StatService {

  constructor(private http: HttpClient, private apiService: ApiService) { }

  apiUrl = `${this.apiService.apiUrl}/stats`;

  getPagesStats(pageIndex: number, pageSize: number, filters: { [key: string]: FilterApplied | undefined }): Observable<PagedResult<PageStats>> {
    let params = new HttpParams()
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString());

    params = this.appendFilters(params, filters);
    return this.http.get<PagedResult<PageStats>>(`${this.apiUrl}`, { params });
  }

  getPagesStatsFilters(): Observable<FilterDescriptor[]> {
    return this.http.get<FilterDescriptor[]>(`${this.apiUrl}/filters`);
  }

  exportPagesStats(filters: { [key: string]: FilterApplied | undefined }): Observable<HttpResponse<Blob>> {
    let params = new HttpParams();
    params = this.appendFilters(params, filters);

    return this.http.get(`${this.apiUrl}/export`, {
      responseType: 'blob',
      observe: 'response',
      params: params
    });
  }

  private appendFilters(
    params: HttpParams,
    filters: { [key: string]: FilterApplied | undefined }
  ): HttpParams {

    Object.keys(filters).forEach(key => {
      const filter  = filters[key];

      if (!filter || !filter.values || !filter.values?.length) return;

      params = params.append(`filters[${key}].type`, filter.type);

      filter.values.forEach(v => {
        params = params.append(`filters[${key}].values`, v);
      });
    });
    return params;
  }
}
